<template>
  <div class="professional-layout">
    <!-- Professional Top Navbar using SurveyTopBar component -->
    <SurveyTopBar />

    <!-- Main Content Area -->
    <div class="pro-content" :class="$route.meta?.bgClass || ''">
      <router-view />
    </div>
  </div>
</template>

<script>
import SurveyTopBar from '@/components/surveys/SurveyTopBar.vue';

export default {
  name: 'ProfessionalLayout',
  components: {
    SurveyTopBar,
  },
};
</script>

<style scoped>
.professional-layout {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.pro-content {
  margin-top: 75px;
  height: calc(100vh - 75px);
  overflow-y: auto;
  padding-left: 2rem;
  padding-right: 2rem;
  box-sizing: border-box;
  background: #f9fbfb;
}

.bg-gray {
  background-color: #f9fbfb;
}

@media (max-width: 999px) {
  .pro-content {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (max-width: 480px) {
  .pro-content {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
